import { useEffect } from 'react'

import lottie from 'lottie-web'

import palette from '@/theme/primaryTheme/palette'

const defaultOptions = {
  loop: true,
  autoplay: true,
  renderer: 'svg',
}

// helper: hex → lottie RGBA
export const hexToLottieRGBA = (hex) => {
  const bigint = parseInt(hex.replace('#', ''), 16)
  const r = ((bigint >> 16) & 255) / 255
  const g = ((bigint >> 8) & 255) / 255
  const b = (bigint & 255) / 255
  return [r, g, b, 1]
}

// mutate lottie JSON globally based on theme color
export const applyThemeToLottie = (json, hexColor) => {
  const rgba = hexToLottieRGBA(hexColor)
  json.layers.forEach((layer) => {
    layer.shapes?.forEach((shape) => {
      shape.it?.forEach((item) => {
        if (item.ty === 'st') {
          item.c.k = rgba
        }
      })
    })
  })
}

export const useLottie = (animationJSON, containerRef, options = {}) => {
  useEffect(() => {
    if (!containerRef) return

    const instance = lottie.loadAnimation({
      container: containerRef.current,
      animationData: animationJSON,
      ...defaultOptions,
      ...options,
    })

    return () => instance.destroy()
  }, [animationJSON, containerRef])
}

export const useApplyThemeToLottie = (
  animationJSON,
  hexColor = palette.primary,
) => {
  useEffect(() => {
    applyThemeToLottie(animationJSON, hexColor)
  }, [animationJSON, hexColor])
}
